export default {
  sm: `
  DATA CENTER GAK to build trust 
  through technology
  `,
  md: `
  DATA CENTER GAK to build trust 
  through technology
  `,
  xxl: `
  DATA CENTER GAK to build trust 
  through technology
  `,
};
